export class XHR415Error extends Error {
  constructor(message: string) {
    super()

    this.message = message || "Формат запроса не поддерживается сервером."
  }
}
